module.exports = "/assets/dist/images/suv_wide.jpg?ed9e0e9a00b792af5c2bda701bba542e";